import React from 'react';
import RegisterForm from '../components/RegisterForm';

const Register: React.FC = () => {
  return (
    <div className="flex-1 flex flex-col">
      <RegisterForm />
    </div>
  );
}

export default Register;
